import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { userStorage } from "../_utils/userStorage";
import {
  setLogoutHandler,
  clearLogoutHandler,
} from "../_utils/apiInterceptor";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = userStorage.getUser();

    if (storedUser) {
      setUser(storedUser);
    }

    setLoading(false);
  }, []);

  const login = (user) => {
    userStorage.setUser(user);
    setUser(user);
  };

  const logout = () => {
    userStorage.clear();
    setUser(null);
  };

  useEffect(() => {
    setLogoutHandler(logout);

    return () => {
      clearLogoutHandler();
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error(
      "useUser must be used inside UserProvider"
    );
  }

  return context;
};